import { createInitialState } from "@dailywars/core/engine";
import type { Coord, GameMap, GameState, Tile } from "@dailywars/core/engine";

const ISLAND_PADDING = 3;
const ISLAND_WIDTH = 5;
const ISLAND_HEIGHT = 7;

function islandCoord(local: Coord): Coord {
  return { x: local.x + ISLAND_PADDING, y: local.y + ISLAND_PADDING };
}

export const TUTORIAL_COORDS = {
  sniperBarracks: islandCoord({ x: 2, y: 0 }),
  factory: islandCoord({ x: 2, y: 1 }),
  neutralCity: islandCoord({ x: 4, y: 0 }),
  sniperAttackFrom: islandCoord({ x: 3, y: 2 }),
  sniperTooFar: islandCoord({ x: 3, y: 1 }),
  tankAttackFrom: islandCoord({ x: 3, y: 3 }),
  enemyBarracks: islandCoord({ x: 3, y: 4 }),
} as const satisfies Record<string, Coord>;

const C1: Tile = { kind: "city", owner: "p1" };
const C2: Tile = { kind: "city", owner: "p2" };
const CN: Tile = { kind: "city", owner: "neutral" };
const B1: Tile = { kind: "barracks", owner: "p1" };
const B2: Tile = { kind: "barracks", owner: "p2" };
const G1: Tile = { kind: "factory", owner: "p1" };
const F: Tile = { kind: "forest" };
const M: Tile = { kind: "mountain" };
const P: Tile = { kind: "plain" };
const W: Tile = { kind: "sea" };

const ISLAND_TILES: Tile[] = [
  C1,
  C1,
  B1,
  F,
  CN,
  C1,
  C1,
  G1,
  P,
  M,
  C1,
  W,
  W,
  P,
  M,
  W,
  W,
  W,
  P,
  M,
  W,
  W,
  W,
  B2,
  M,
  W,
  W,
  W,
  C2,
  M,
  W,
  W,
  W,
  C2,
  M,
];

function buildPaddedMapTiles(island: Tile[]): Tile[] {
  const width = ISLAND_WIDTH + ISLAND_PADDING * 2;
  const height = ISLAND_HEIGHT + ISLAND_PADDING * 2;
  const tiles: Tile[] = [];

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const localX = x - ISLAND_PADDING;
      const localY = y - ISLAND_PADDING;
      const onIsland =
        localX >= 0 && localX < ISLAND_WIDTH && localY >= 0 && localY < ISLAND_HEIGHT;
      tiles.push(onIsland ? island[localY * ISLAND_WIDTH + localX]! : W);
    }
  }

  return tiles;
}

export const TUTORIAL_MAP: GameMap = {
  id: "tutorial",
  width: ISLAND_WIDTH + ISLAND_PADDING * 2,
  height: ISLAND_HEIGHT + ISLAND_PADDING * 2,
  tiles: buildPaddedMapTiles(ISLAND_TILES),
  startingUnits: [],
};

export function createTutorialInitialState(): GameState {
  return createInitialState(TUTORIAL_MAP);
}
